export const APP_VERSION = '2.5.7';
export const APP_BUILD_DATE = '26 Octombrie 2026';
export const APP_BUILD_TAG = 'Optimizare antet sală și bară admin pe un singur rând, eliminare Demo/Producție, mărire logo oficial';

